import * as React from 'react';
import { Text, Card, CardHeader, Button, Spinner, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';
import { ContractStageType } from '../../../../models/Entities/Contracts/ContractStageType';
import * as ComponentFunctions from './StageTypeList.Functions';
import { connect } from 'react-redux';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import StageTypeFormComponent from '../StageTypeForm/StageTypeForm.Component';
import { Delete20Regular } from '@fluentui/react-icons';
import ConfirmDialog from '../../../../commons/component/ConfirmDialog/ConfirmDialog';
import { GuideDrawer } from '../../../../theme/components/GuideDrawer';

const useStageTypeListStyles = makeStyles({
    list: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalM,
    },
    card: {
        position: 'relative',
        ...shorthands.border(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke1),
    },
    cardDeleting: {
        opacity: 0.6,
    },
    cardCorner: {
        position: 'absolute',
        top: tokens.spacingVerticalS,
        right: tokens.spacingHorizontalS,
    },
    spinner: {
        zIndex: 2,
    },
    deleteButton: {
        zIndex: 3,
        color: tokens.colorStatusDangerForeground1,
    },
});

export const StageTypeListComponent = (props: any) => {
    const { isOpen, dismissPanel, ContractStageTypes } = props;
    const styles = useStageTypeListStyles();
    const [showForm, setShowForm] = useState(false);
    const [editingStageType, setEditingStageType] = useState<ContractStageType | null>(null);
    const [deletingId, setDeletingId] = useState<number | null>(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmItem, setConfirmItem] = useState<ContractStageType | null>(null);
    const { t } = useTranslation();

    const openConfirm = (item: ContractStageType) => {
        setConfirmItem(item);
        setConfirmOpen(true);
    };

    const handleConfirmDelete = () => {
        if (confirmItem) {
            setDeletingId(confirmItem.id);
            if (props.DeleteContractStageType) {
                Promise.resolve(props.DeleteContractStageType(confirmItem.id)).finally(() => setDeletingId(null));
            } else {
                setDeletingId(null);
            }
        }
        setConfirmOpen(false);
        setConfirmItem(null);
    };

    const handleCancelDelete = () => {
        setConfirmOpen(false);
        setConfirmItem(null);
    };

    return (
        <GuideDrawer
            open={!!isOpen}
            onDismiss={dismissPanel}
            size="large"
            title="Listado de tipos de etapa"
            secondaryAction={{}}
            testId="stage-type-list-drawer"
        >
            <div>
                <Button appearance="primary" onClick={() => { setShowForm(true); setEditingStageType(null); }}>
                    Agregar nuevo tipo de etapa
                </Button>
            </div>
            {showForm && (
                <StageTypeFormComponent
                    dismissPanel={() => { setShowForm(false); setEditingStageType(null); }}
                    isOpen={showForm}
                    StageTypeId={editingStageType?.id || undefined}
                    openPanel={function (): void {
                        throw new Error('Function not implemented.');
                    }}
                />
            )}
            <div className={styles.list} data-testid="stage-type-list">
                {ContractStageTypes && ContractStageTypes.length > 0 ? (
                    ContractStageTypes.map((stageType: ContractStageType) => (
                        <Card
                            key={stageType.id}
                            className={mergeClasses(styles.card, deletingId === stageType.id && styles.cardDeleting)}
                            onClick={e => {
                                e.stopPropagation();
                                setEditingStageType(stageType);
                                setShowForm(true);
                            }}
                        >
                            <CardHeader
                                header={<Text weight="semibold">{stageType.name}</Text>}
                                description={stageType.description || ''}
                            />
                            {deletingId === stageType.id && (
                                <div className={mergeClasses(styles.cardCorner, styles.spinner)}>
                                    <Spinner size="tiny" label="Eliminando..." />
                                </div>
                            )}
                            <Button
                                appearance="subtle"
                                className={mergeClasses(styles.cardCorner, styles.deleteButton)}
                                disabled={deletingId === stageType.id}
                                onClick={e => {
                                    e.stopPropagation();
                                    openConfirm(stageType);
                                }}
                            >
                                <Delete20Regular />
                            </Button>
                        </Card>
                    ))
                ) : (
                    <Text>No hay tipos de etapa disponibles.</Text>
                )}
            </div>
            <ConfirmDialog
                open={confirmOpen}
                title={t('confirmDialog.deleteTitle', 'Confirmar eliminación')}
                message={t('confirmDialog.deleteMessage', 'Esta acción no se puede deshacer.')}
                highlight={confirmItem?.name || ''}
                confirmText={t('commons.confirmationModal.confirm', 'Confirmar')}
                cancelText={t('commons.confirmationModal.cancel', 'Cancelar')}
                onConfirm={handleConfirmDelete}
                onCancel={handleCancelDelete}
            />
        </GuideDrawer>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(StageTypeListComponent as any);
